<template>
    <div class="node-container">
        <div class="content">
            <img src="@/assets/image/requirement/step5-complete.png" alt="">
            <h2>流程已结束</h2>
        </div>
        <!-- 底部按钮 -->
        <div class="footer-operation" v-if="type != 'preview'">
            <el-button @click="onRollback">上一步</el-button>
            <el-button type="primary" @click="handleClose">关闭</el-button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        requirementId: [Number, String],
        currentStep: [Number, String],
        // 弹窗类型：add 新增 | edit 编辑 | preview 预览
        type: String,
    },
    computed: {
        // 进度是否为当前节点
        isCurrent() {
            return this.currentStep === 5 ? true : false
        }
    },
    methods: {
        // 点击“上一步” 回退步骤
        onRollback() {
            this.$emit('rollback');
        },
        // 点击“关闭”
        handleClose() {
            this.$emit("close");
        }
    }
}
</script>

<style lang="scss" scoped>
.content {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-height: 360px;
    padding-top: 30px;
    img {
        width: 160px;
    }
}
.footer-operation {
    display: flex;
    justify-content: center;
    margin-top: 30px;
    > .el-button {
        height: 32px;
        line-height: 31px;
        padding-top: 0;
        padding-bottom: 0;
    }
}
</style>